import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Lightbulb } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              {/* <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center">
                <Lightbulb className="w-6 h-6 text-white" />
              </div> */}
              {/* <div>
                <h3 className="text-xl font-bold">Udbhav 2.0</h3>
                <p className="text-sm text-gray-400">Ignite Ideas, Fuel Innovation</p>
              </div> */}
                <img src="/images/logo.png" alt="logotype" style={{ height: 60 }} />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              ONGC's flagship innovation platform driving digital transformation and empowering employees to shape the future.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
        {/* <a
  href="https://docs.google.com/forms/d/e/1FAIpQLSekok3wYw-j3eSw0OGBB1amsopP7PzZ4H0NHkQ9WDcFLEPyfA/viewform"
  target="_blank"
  rel="noopener noreferrer"
  className="text-gray-400 hover:text-white transition-colors duration-200"
>
 Submit Use Case Idea
</a> */}
      
          </li>
            <li>
                <Link to="/submission-insights" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Submission Insights
                </Link>
              </li> 
              <li>
                <Link to="/udbhav-case" className="text-gray-400 hover:text-white transition-colors duration-200">
                Udbhav 1.0 Use Cases
                </Link>
              </li> 
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Resources</h4>
            <ul className="space-y-3">
                   <li>
                <Link to="/knowledge-center" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Knowledge Center
                </Link>
              </li>
              <li>
                <Link to="/alumni" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Alumni Platform  
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Help 
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
<li className="flex items-start space-x-3">
  <Mail className="w-5 h-5 text-blue-400 mt-0.5" />
  <div className="flex flex-col">
    <span className="text-gray-400 text-sm">udbhav@oges.co</span>
    <span className="text-gray-400 text-sm">vyas_rishi@ongc.co.in</span>
  </div>
</li>

              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-blue-400 mt-0.5" />
                <span className="text-gray-400 text-sm">+91-98211 06466</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 mt-0.5" />
                <span className="text-gray-400 text-sm">ONGC 12th Floor, Scope Minar, Laxmi Nagar, New Delhi, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex justify-center items-center">
            <p className="text-gray-400 text-sm text-center">
             ONGC. All rights reserved.
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;